import React from 'react';

function CompactTimeline() {
  // 타임라인 데이터 (시간순으로 정렬)
  const timelineData = [
    {
      id: 1,
      title: '체인플루언서',
      description: '블록체인 커뮤니티',
      role: '운영자 / 마케터',
      startDate: '2018.03',
      endDate: '2020.12',
      status: 'completed',
      icon: '🚀'
    },
    {
      id: 2,
      title: '트리픽',
      description: '취향별 여행지 추천 SNS',
      role: '개발자',
      startDate: '2019.09',
      endDate: '2023.05',
      status: 'completed',
      icon: '✈️'
    },
    {
      id: 3,
      title: '마이쉐어루틴, 히든마켓',
      description: '개인 사이드 프로젝트 진행',
      role: '개발자',
      startDate: '2023.05',
      endDate: '2023.11',
      status: 'completed',
      icon: '💼'
    },
    {
      id: 4,
      title: '밋유',
      description: '궁금증 유발 감성 가치관 소개팅',
      role: '개발자',
      startDate: '2024.01',
      endDate: '2024.06',
      status: 'completed',
      icon: '💕'
    },
    {
      id: 5,
      title: '월리',
      description: '반려동물 돌봄 이웃',
      role: 'COO/PM ',
      startDate: '2024.04',
      endDate: '2025.06',
      status: 'completed',
      icon: '🐾'
    },
    {
      id: 6,
      title: '클로버리',
      description: '디온 포트폴리오 브랜드 운영',
      role: '',
      startDate: '2025.12',
      endDate: null,
      status: 'ongoing',
      icon: '🍀'
    },
    {
      id: 7,
      title: '코드스테이츠 프론트엔드 6개월 수료',
      description: '',
      role: '',
      startDate: '2022.08',
      endDate: '2023.02',
      status: 'completed',
      icon: '📚'
    },
    {
      id: 8,
      title: '코드잇 풀스택 개발 과정 수료',
      description: '',
      role: '',
      startDate: '2022.08',
      endDate: '2023.02',
      status: 'completed',
      icon: '💻'
    },
    {
      id: 9,
      title: "'넌 언제든, 시작할 수 있어' 디온 에세이 출판",
      description: '',
      role: '작가',
      startDate: '2022.12',
      endDate: '2023.02',
      status: 'completed',
      icon: '📖'
    },
    {
      id: 10,
      title: '웅진씽크빅 / 스나이퍼 팩토리 디자이너 인턴십 수료',
      description: '',
      role: '디자이너 인턴',
      startDate: '2023.11',
      endDate: '2024.02',
      status: 'completed',
      icon: '🎨'
    },
    {
      id: 11,
      title: '올웨이즈 Problem Solver 스카웃 제의',
      description: '',
      role: '',
      startDate: '2025.06',
      endDate: '보류',
      status: 'completed',
      icon: '⭐'
    },
    {
      id: 12,
      title: '음악 유튜브 운영',
      description: '',
      role: '',
      startDate: '2025.07',
      endDate: null,
      status: 'ongoing',
      icon: '🎻'
    },
        {
      id: 12,
      title: '모멘트립 출시 및 운영',
      description: "순간을 여행처럼",
      role: '개발자',
      startDate: '2026.04',
      endDate: null,
      status: 'ongoing',
      icon: '📸'
    },
    
  ];

  // 날짜 파싱 함수
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [year, month] = dateStr.split('.');
    return new Date(parseInt(year), parseInt(month) - 1);
  };

  // 시간순 정렬
  const sortedData = [...timelineData].sort((a, b) => {
    const dateA = parseDate(a.startDate);
    const dateB = parseDate(b.startDate);
    if (!dateA) return 1;
    if (!dateB) return -1;
    return dateB - dateA; // 최신순
  });

  return (
    <div className="compact-timeline-container">
      <div className="compact-timeline-wrapper">
        <div className="compact-timeline-line"></div>
        <div className="compact-timeline-items">
          {sortedData.map((item, index) => {
            let duration;
            if (!item.endDate) {
              duration = `${item.startDate} ~ 진행중`;
            } else if (item.endDate === '보류') {
              duration = item.startDate;
            } else {
              duration = `${item.startDate} ~ ${item.endDate}`;
            }

            return (
              <div 
                key={item.id} 
                className={`compact-timeline-item ${item.status}`}
              >
                <div className="compact-timeline-dot"></div>
                <div className="compact-timeline-content">
                  <div className="compact-timeline-header">
                    <span className="compact-timeline-icon">{item.icon}</span>
                    <div className="compact-timeline-title-wrapper">
                      <span className="compact-timeline-title">{item.title}</span>
                      {item.description && (
                        <span className="compact-timeline-description">{item.description}</span>
                      )}
                      {item.role && (
                        <span className="compact-timeline-role">{item.role}</span>
                      )}
                    </div>
                  </div>
                  <div className="compact-timeline-footer">
                    <span className="compact-timeline-date">{duration}</span>
                    {item.status === 'ongoing' && (
                      <span className="compact-timeline-badge ongoing">진행중</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CompactTimeline;

